// extracted by mini-css-extract-plugin
export default {"container":"n6Fhpwr zFMy58l","noisyText":"dW9_H8j zFMy58l"};